import { IWidget, IWidgetDefinition, SubFilter } from '../../common/core';
import { CheckFacetData, SortOption } from '../checkwidget/checkfacetdata';
import { ITreeFacetSettings, ITreeFacetState, TreeItem } from './settings';

var template = require("../treefacet.widget/treefacet.html");
var styles = require("../treefacet.widget/treefacet.scss").toString();

class TreeFacetData extends CheckFacetData<TreeItem> {
    preventNextChange: number = 0;
    missedCount: number = 0;
    totalCount: number = 0;

    showMoreSearchingSpinner: boolean;
    searchTermString: string;
    showSearchTermInput: boolean;
    allSearchTermResults = [];
    addMoreListMaxHeight: number;
    highligted: number = null;
    searchMore: boolean; // show a message on very bottom if not all "More" options are shown 
    showLookup: boolean;

    /**
     * View theme
     */
    theme?: string;

    constructor(public widget: IWidget<TreeFacetData, ITreeFacetSettings, ITreeFacetState>) {
        super(widget);

        /*
        if (widget.settings.inverseAllowed) {
            widget.service.captureMessage('Treefacet: inverseAllowed');
        }
        */

        // hide search results block after click outside except of search input
        document.addEventListener('mouseup', this.globalMoreMouseupHandler);
        document.addEventListener('keydown', this.globalMoreKeydownHandler);

        this.theme = this.widget.service.getGlobalOptions().theme;
    }

    get showMoreMaxFacets() {
        return this.widget.settings.showMoreMaxFacets || 800;
    }

    destroy() {
        document.removeEventListener('mouseup', this.globalMoreMouseupHandler);
        document.removeEventListener('keydown', this.globalMoreKeydownHandler);
    }

    markAsChecked(fullName: string, item: TreeItem) {
        // remove children items
        var fPrefix = fullName + '\\';
        if (this.widget.state.selected) {
            for (let key in this.widget.state.selected) {
                if (key.indexOf(fPrefix) != -1) {
                    delete this.widget.state.selected[key];
                }
            }
        }

        if (!this.widget.state.selected) {
            this.widget.state.selected = {};
        }

        if (this.isSelectedMode()) {
            if (this.widget.state.selected[fullName] === false) {
                delete this.widget.state.selected[fullName];
                return;
            } else {
                this.widget.state.selected[fullName] = true;
            }
        } else {
            //if (this.widget.state.selected[fullName] === true) {
            //    this.widget.state.selected[fullName] = false;
            //    return;
            //} else {
            delete this.widget.state.selected[fullName];
            //}
        }

        if (this.widget.settings.radio) {
            return;
        }

        var nameParts = fullName.split('\\');
        nameParts.pop();

        // find items and prefix for all parents
        var folderItems: TreeItem[][] = [];
        var prefixes: string[] = [];
        var terms = this.terms;
        var currentPath;
        for (let p of nameParts) {
            currentPath = currentPath ? `${currentPath}\\${p}` : `${p}`;
            prefixes.push(currentPath);
            if (terms) {
                var t = terms.filter(x => x.term == p)[0];
                if (t) {
                    terms = t.children;
                    if (terms) {
                        folderItems.push(terms);
                    }
                }
            }
        }

        folderItems.reverse();
        prefixes.reverse();

        // iterate through all parents
        for (var fi = 0; fi < folderItems.length; fi++) {
            let fitems = folderItems[fi];
            let prefix = prefixes[fi];
            var allChecked = true;


            fitems.forEach(item => {
                if (this.formatTreeName(prefix, item) == fullName) {
                    return;
                }
                if (!this.isChecked(item, prefix)) {
                    allChecked = false;
                }
            });

            if (allChecked) { //remove selected children and select
                fitems.forEach(item => {
                    if (this.widget.state.selected) {
                        delete this.widget.state.selected[this.formatTreeName(prefix, item)];
                    }
                });
                if (!this.widget.state.selected) {
                    this.widget.state.selected = {};
                }

                if (this.isSelectedMode()) {
                    this.widget.state.selected[prefix] = true;
                } else {
                    delete this.widget.state.selected[prefix];
                    // this.widget.state.selected[prefix] = false;
                }
                // if parent is unselected and we selected some child item
            } else if (!this.isSelectedMode() && this.widget.state.selected && this.widget.state.selected[prefix] === false) {
                delete this.widget.state.selected[prefix];
                fitems.forEach(item => {
                    if (this.formatTreeName(prefix, item) == fullName) {
                        delete this.widget.state.selected[fullName];
                    } else {
                        this.widget.state.selected[this.formatTreeName(prefix, item)] = false;
                    }
                });
            } else {
                break;
            }
        }

        // TODO: add logic to select parent folder if all children are selected
    }

    markAsUnchecked(fullName: string, item: TreeItem) {
        // exact name match
        if (this.widget.state.selected && this.widget.state.selected[fullName]) {
            delete this.widget.state.selected[fullName];
            if (!Object.keys(this.widget.state.selected).length) {
                delete this.widget.state.selected;
            }
        } else {

            var parts = fullName.split('\\');
            var parentNames = [];
            var prevName;
            for (let part of parts) {
                if (prevName) {
                    prevName = prevName + '\\' + part;
                } else {
                    prevName = part;
                }
                parentNames.push(prevName);
            }

            parentNames.pop(); // remove first name (and leave only parent folders)
            parentNames.reverse();

            // uncheck parents and check all other children
            var found = false;

            if (this.isSelectedMode()) {
                // iterate from current item to the root
                var level = 0;
                for (let parentName of parentNames) {
                    var navPath = parentName.split('\\');

                    // find folder items
                    var terms = this.terms;
                    for (var p of navPath) {
                        if (terms) {
                            terms = terms.filter(x => x.term == p)[0].children;
                        }
                    }

                    if (terms) {
                        terms.forEach(t => {
                            // go through all children
                            if (t.term !== item.term) { // ignore unchecked item
                                var n = `${parentName}\\${t.term}`;
                                if (parentNames.indexOf(n) == -1) { // ignore all folders
                                    if (!this.widget.state.selected) {
                                        this.widget.state.selected = {};
                                    }

                                    // if item already unchecked through search then just remove key
                                    if (this.widget.state.selected[n] === false) {
                                        delete this.widget.state.selected[n];
                                    } else {
                                        // otherwise set them checked
                                        this.widget.state.selected[n] = true;
                                    }
                                }
                            }
                        });
                    } else {
                        if (level === 0 && !terms) {
                            // if children terms not found then this is search (using search icon) and we should uncheck items using `false` value
                            this.widget.state.selected[fullName] = false;
                            break;
                        }
                    }

                    // if matched parent is selected then we unselect it and break
                    if (this.widget.state.selected && this.widget.state.selected[parentName]) {
                        delete this.widget.state.selected[parentName];
                        if (!Object.keys(this.widget.state.selected).length) {
                            delete this.widget.state.selected;
                        }
                        break;
                    }

                    level++;
                }
            } else {
                if (parentNames.length) {
                    // iterate from current item to the root
                    var level = 0;
                    for (let parentName of parentNames) {
                        var navPath = parentName.split('\\');

                        // find folder items
                        var terms = this.terms;
                        for (var p of navPath) {
                            if (terms) {
                                terms = terms.filter(x => x.term == p)[0].children;
                            }
                        }

                        if (!this.widget.state.selected) {
                            this.widget.state.selected = {};
                        }
                        if (terms) {
                            var allUnchecked = true;
                            terms.forEach(t => {
                                // go through all children
                                var n = `${parentName}\\${t.term}`;
                                if (t.term === item.term) { // ignore unchecked item
                                    this.widget.state.selected[n] = false;
                                }
                                if (allUnchecked) {
                                    allUnchecked = this.widget.state.selected[n] === false;
                                }
                            });

                            // if all unchecked then uncheck parent and remove child
                            if (allUnchecked) {
                                this.widget.state.selected[parentName] = false;
                                terms.forEach(t => {
                                    var n = `${parentName}\\${t.term}`;
                                    delete this.widget.state.selected[n];
                                });
                            }
                        } else {
                            if (level === 0 && !terms) {
                                // if children terms not found then this is search (using search icon) and we should uncheck items using `false` value
                                this.widget.state.selected[fullName] = true;
                                break;
                            }
                        }

                        /*
                        // if matched parent is selected then we unselect it and break
                        if (this.widget.state.selected && this.widget.state.selected[parentName]) {
                            delete this.widget.state.selected[parentName];
                            if (!Object.keys(this.widget.state.selected).length) {
                                delete this.widget.state.selected;
                            }
                            break;
                        }
                        */

                        level++;
                    }
                } else {
                    if (!this.widget.state.selected) {
                        this.widget.state.selected = {};
                    }
                    this.widget.state.selected[fullName] = false;
                }
                return;
            }


        }
    }

    /**
     * Returns default checked behavior
     * true - default is unchecked
     * false - default is checked
     */
    isSelectedMode() {
        if (this.isCheckedUncheckedMode()) {
            return this.widget.state.all === false;
        } else {
            return true;
        }
    }

    isCheckedUncheckedMode() {
        // return this.widget.settings.inverseAllowed;
        return false;
    }

    // ------------------------- "All" checkbox -----------------------------
    check(item: TreeItem, prefix: string) {
        // `setTimeout` used to fix issue in IE when `checked` goes to not sync state with [checked]
        setTimeout(() => {
            var fullName = this.formatTreeName(prefix, item);

            var isDirectlyChecked = this.widget.state.selected && this.widget.state.selected[fullName];
            var isSelected = this.isChecked(item, prefix);

            if (this.widget.settings.radio) {
                this.clearCheck(false);
                isSelected = false;

                if (isDirectlyChecked && this.widget.settings.showNull) {
                    this.preventNextChange++;
                    this.widget.service.setState();
                    return;
                }
            }

            //core logic
            var setChecked = !isSelected;

            // if inverse -> selected === checked
            // if not inverse -> selected === unchecked
            // if(!this.isSelectedMode()) {
            //    setChecked = !setChecked;
            // }
            if (setChecked) {
                this.markAsChecked(fullName, item);
            } else {
                this.markAsUnchecked(fullName, item);
            }

            if (this.widget.state.preselected === false) {
                delete this.widget.state.preselected;
            }

            this.preventNextChange++;
            this.widget.service.setState();

            this.widget.service.getConfig().trackAction('treefacet:toggle', this.widget, {
                isSelected: setChecked,
                label: fullName,
                facetLabel: this.widget.settings.name
            });
        });
    }

    clickBeforeCheck(item, prefix, event) {
        if (this.widget.settings.radio) {
            if (this.isChecked(item, prefix)) {

                var fullName = this.formatTreeName(prefix, item);

                if (!this.widget.state.selected || !this.widget.state.selected[fullName]) {
                    this.clearCheck(false);
                    if (!this.widget.state.selected) {
                        this.widget.state.selected = {};
                    }
                    this.widget.state.selected[fullName] = true;
                    this.preventNextChange++;
                    this.widget.service.setState();
                }

                if (!this.widget.settings.showNull) {
                    if (event) {
                        event.preventDefault();
                    }
                    return false;
                }
            }
        }
    }

    __isSelected(item: TreeItem, prefix: string, checkedMap: any) {
        var fullName = this.formatTreeName(prefix, item);

        // unchecked this item
        if (checkedMap && checkedMap[fullName] === false) {
            return false;
        }

        // child is checked or not checked
        if (checkedMap && (!this.widget.settings.radio || this.widget.data.theme)) {
            for (var sKey in checkedMap) {
                // check parent
                if (sKey.indexOf(fullName + '\\') === 0) {
                    return null;
                }

                // check children
                if (this.widget.settings.radio && fullName.indexOf(sKey + '\\') === 0) {
                    return true;
                }
            }
        }

        // checked this item (only if no unchecked children)
        if (checkedMap && checkedMap[fullName]) {
            return true;
        }

        if (this.widget.settings.radio) {
            return false;
        }

        // parent is checked
        var parts = fullName.split('\\');
        var name;
        for (var part of parts) {
            if (name) {
                name = name + '\\' + part;
            } else {
                name = part;
            }
            if (checkedMap && checkedMap[name] === true) {
                return true;
            }
            if (checkedMap && checkedMap[name] === false)
                return false;
        }

        return this.isSelectedMode() ? false : true;
    }

    // `true` - marked in state, `false` - not marked, `null` - partially checked/unchecked
    _isSelected(item: TreeItem, prefix: string) {
        var res = this.__isSelected(item, prefix, this.widget.state.selected);
        if (!res && this.widget.state.preselected !== false) {
            res = this.__isSelected(item, prefix, this.preselected);
        }
        return res;
    }

    // `true` - checked, `false` - unchecked, `null` - partially checked/unchecked
    isChecked(item: TreeItem, prefix: string) {
        var selected = this._isSelected(item, prefix);
        return selected;
    }

    isDisabled(item: TreeItem, prefix: string) {
        /*
        if (this.widget.settings.radio && item.more) {
            return true;
        }
        */
        if (this.__isSelected(item, prefix, this.preselected)) {
            return true;
        }
        return false;
    }

    toggle(e: Event, item: TreeItem, prefix: string) {
        if (e) {
            e.stopPropagation();
        }

        // expand with already loaded items
        if (item.children && item.collapsed) {
            const childrenPrefix = this.formatTreeName(prefix, item);
            this.sortFieldsWithChecked(item.children, childrenPrefix);

            delete item.collapsed;
            return;
        }

        // collapse
        if (item.children && !item.collapsed) {
            item.collapsed = true;
            return;
        }

        // load and expand
        this.loadChildren(e, item, prefix);
    }

    loadChildren(e: Event, item: TreeItem, prefix: string, showMore?: boolean) {
        if (e) {
            e.stopPropagation();
        }

        // load and expand
        const fp = this.formatTreeName(prefix, item);
        let fieldPath = fp;

        // for the facets if there is a , in the @tree operator param, you have to quote the whole param in "
        // otherwise API thinks you are doing multiple facets because we use , as special delimit character
        if (fieldPath && fieldPath.indexOf(',') != -1) {
            fieldPath = `"${fieldPath}"`;
        }

        const field = this.widget.data.fieldWithSort(fieldPath);
        const maxFacets = showMore ? this.showMoreMaxFacets : this.widget.settings.maxFacets || 100;

        item['loading'] = true;

        this.widget.awaitGlobalQueryWithoutMe().then(query => {

            var request = {
                per_page: 0,
                query: query,
                facets: field,
                max_facet_values: maxFacets,
            };

            var default_fields = this.widget.service.seriesParam.default_fields;
            if (default_fields) {
                if (typeof default_fields == 'function') {
                    default_fields = default_fields(this.widget.service);
                }
                request['default_fields'] = default_fields;
            }

            this.widget.service.sjclient.raw.get(this.widget.service.search_api_path, request, (response: any) => {
                const facets = response.facets || {};
                const facet = facets[field] || {};
                let terms = facet.terms || [];

                // add missed keys (if api doesn't return some items)
                if (this.widget.state.selected) {
                    const apiTerms = {};
                    terms.forEach((t: any) => {
                        apiTerms[t.term] = 1
                    });

                    var itemsToCheck = [];

                    const sfp = fp + '\\';
                    Object.keys(this.widget.state.selected)
                        .filter(x => {
                            return x.indexOf(sfp) == 0;
                        })
                        .map(x => {
                            return x.substr(sfp.length).split('\\');
                        })
                        .filter(x => x.length == 1)
                        .map(x => x[0])
                        .forEach(x => {
                            if (!apiTerms[x]) {
                                var t = {
                                    term: x
                                };
                                terms.push(t);
                                itemsToCheck.push(t);
                            }
                        });

                    // some selected items can be missed in response.
                    // so we manually added them, but don't know if they have child terms or not
                    // thats we load every these items anc set `more` and `count`
                    if (itemsToCheck.length) {
                        var extraFacets = itemsToCheck.map(f => {
                            let fq = this.widget.data.fieldWithSort(`${fieldPath}\\${f.term}`);
                            return {
                                path: fq,
                                item: f
                            };
                        });

                        var r = {
                            per_page: 0,
                            query: query,
                            facets: extraFacets.map(f => f.path).join(','),
                            max_facet_values: 1
                        };
                        var default_fields = this.widget.service.seriesParam.default_fields;
                        if (default_fields) {
                            if (typeof default_fields == 'function') {
                                default_fields = default_fields(this.widget.service);
                            }
                            r['default_fields'] = default_fields;
                        }

                        this.widget.service.sjclient.raw.get(this.widget.service.search_api_path, r, (response) => {
                            if (response.success && response.facets) {
                                extraFacets.forEach(x => {
                                    var fmatch = response.facets[x.path];
                                    if (fmatch) {
                                        x.item.count = fmatch.total;
                                        x.item.more = !!fmatch.terms?.length;
                                    }
                                });
                            }
                        });
                    }
                }

                if (this.widget.settings.adjustFacets) {
                    terms = this.widget.settings.adjustFacets(this.widget, terms, item, prefix, null);
                }
                item['loading'] = false;
                item.children = terms;

                this.sortFieldsWithChecked(item.children, fieldPath);

                if (facet.other && terms.length < this.showMoreMaxFacets) {
                    item.showMore = true;
                } else {
                    item.showMore = false;
                }
            });
        });
    }

    sortFieldsWithChecked(items: TreeItem[], prefix: string) {
        /*
        if (this.widget.settings.adjustFacets) {
            // do nothing if there adjustFacets
            return;
        }
        if (prefix) {
            items.forEach((x, i) => {
                x['_index'] = i;
            });
        }
        items.sort((a, b) => {
            const isAChecked = this.isChecked(a, prefix);
            const isBChecked = this.isChecked(b, prefix);
            if (isAChecked === isBChecked) {
                const { sort } = this.widget.settings;

                if (sort === SortOption.termAsc) {
                    return a.term < b.term ? -1 : (a.term > b.term ? 1 : 0);
                } else if (sort === SortOption.termDesc) {
                    return a.term < b.term ? 1 : (a.term > b.term ? -1 : 0);
                } else if (sort === SortOption.countAsc) {
                    return a.count < b.count ? -1 : (a.count > b.count ? 1 : 0);
                } else {
                    return a.count < b.count ? 1 : (a.count > b.count ? -1 : 0);
                }
            }

            return isAChecked !== false ? -1 : 1;
        });

        if (prefix) {
            var sortChanged = false;
            items.forEach((x, i) => {
                if (i !== x['_index']) {
                    sortChanged = true;
                }
            });
            if (sortChanged) {
                // seems the whole method not really necessary
                // TODO: remove if there will be no messages in sentry
                this.widget.service.captureMessage('TreeFacet terms order changed...');
            }
        }
        */
    }

    formatTreeName(prefix: string, item: TreeItem) {
        if (!prefix)
            return `${item.term}`;
        return `${prefix}\\${item.term}`;
    }
    setTerms(terms: TreeItem[]) {
        if (terms) {
            terms = JSON.parse(JSON.stringify(terms));
        }

        if (this.widget.settings.adjustFacets) {
            terms = this.widget.settings.adjustFacets(this.widget, terms, null, null, null);
        }
        this.terms = terms;

        const apiTerms = {};
        terms.forEach((t: any) => {
            apiTerms[t.term] = 1
        });

        if (this.widget.state.selected) {
            var itemsToCheck = [];
            Object.keys(this.widget.state.selected)
                .map(x => {
                    return x.split('\\');
                })
                .filter(x => x.length == 1)
                .map(x => x[0])
                .forEach(x => {
                    if (!apiTerms[x]) {
                        var t = {
                            term: x,
                            more: false,
                            count: null
                        };
                        terms.push(t);
                        itemsToCheck.push(t);
                    }
                });

            // some selected items can be missed in response.
            // so we manually added them, but don't know if they have child terms or not
            // thats we load every these items anc set `more` and `count`
            if (itemsToCheck.length) {
                var extraFacets = itemsToCheck.map(f => {
                    let fq = `${this.widget.settings.field}@tree:${f.term}`;
                    return {
                        path: fq,
                        item: f
                    };
                });
                this.widget.awaitGlobalQueryWithoutMe().then(query => {

                    var r = {
                        per_page: 0,
                        query: query,
                        facets: extraFacets.map(f => f.path).join(','),
                        max_facet_values: 1
                    }
                    var default_fields = this.widget.service.seriesParam.default_fields;
                    if (default_fields) {
                        if (typeof default_fields == 'function') {
                            default_fields = default_fields(this.widget.service);
                        }
                        r['default_fields'] = default_fields;
                    }

                    this.widget.service.sjclient.raw.get(this.widget.service.search_api_path, r, (response) => {
                        if (response.success && response.facets) {
                            extraFacets.forEach(x => {
                                var fmatch = response.facets[x.path];
                                if (fmatch) {
                                    x.item.count = fmatch.total;
                                    x.item.more = !!fmatch.terms?.length;
                                }
                            });
                        }
                    });
                });
            }
        }
    }

    /**
     * Get global query promise
     * Can be overridden in widgets
     */
    public getGlobalQuery(): Promise<string> {
        return this.widget.service.awaitGlobalQuery(this.widget, true, false);
    }

    requestFacets(size, callback) {
        const facets = this.fieldWithSort();
        this.getGlobalQuery().then(query => {

            var request = {
                per_page: 0,
                query: query,
                facets,
                max_facet_values: 100
            };
            var default_fields = this.widget.service.seriesParam.default_fields;
            if (default_fields) {
                if (typeof default_fields == 'function') {
                    default_fields = default_fields(this.widget.service);
                }
                request['default_fields'] = default_fields;
            }

            this.widget.service.sjclient.raw.get(this.widget.service.search_api_path, request, (response) => {
                var facetsResponse = response.facets && response.facets[facets] || {};
                this.missedCount = facetsResponse.missing;
                this.totalCount = facetsResponse.total;
                callback(facetsResponse.terms || []);
            });
        });
    }

    countMouseEnter(e) {
        var el = e.target;
        el.style.setProperty('--sj-textf-width', el.offsetParent.offsetWidth + 'px');
        el.style.setProperty('--sj-textf-count-left', el.offsetLeft + 'px');
    }

    checkAll(forceAll = true) {
        // `setTimeout` used to fix issue in IE when `checked` goes to not sync state with [checked]
        setTimeout(() => {
            if (this.widget.settings.showNull || this.isCheckedUncheckedMode()) {

                if (super.isAllChecked()) { // if no items selected than we can only toggle `state.all`
                    if (this.widget.state.all === false) {
                        delete this.widget.state.all;
                    } else {
                        this.widget.state.all = false;
                    }
                    this.clearCheck(false, null);
                } else { // if some items are selected than we can only turn on `All` checkbox and delete `state.all`
                    delete this.widget.state.all;
                    this.clearCheck(false, null);
                }

                if (this.widget.settings.onChange) {
                    this.widget.settings.onChange(this.widget);
                }
                if (this.widget.settings.setState !== false) {
                    this.widget.service.setState(this.widget.settings.ignoreQuery);
                }
            } else {
                super.checkAll(forceAll);
            }
        });
    }

    isAllChecked() {
        if (this.widget.settings.showNull || this.isCheckedUncheckedMode()) {
            return super.isAllChecked() && this.widget.state.all !== false;
        } else {
            return super.isAllChecked();
        }
    }

    isAllDisabled() {
        if (this.isCheckedUncheckedMode()) {
            return false;
        }
        return this.isAllChecked() && !this.widget.settings.showNull && !this.preselected;
    }

    /*
     * Returns `true` if should make a separate request to load facets, `false` - means to use data from `onData` call
     */
    get shouldMakeSeparateRequest() {
        return this.getSelArray().length || this.widget.state.nullable === false || this.widget.state.all === false;
    }

    // number of facets for "More"
    get moreMaxFacets() {
        return this.widget.settings.moreMaxFacets || 20;
    }

    filterFacets(size, term_filter, callback) {
        this.widget.awaitGlobalQueryWithoutMe().then(query => {
            const facets = `${this.field}${this.sortQuery}@filter:${term_filter}`;


            var request = {
                per_page: 0,
                query: query,
                facets: facets,
                max_facet_values: size
            };
            var default_fields = this.widget.service.seriesParam.default_fields;
            if (default_fields) {
                if (typeof default_fields == 'function') {
                    default_fields = default_fields(this.widget.service);
                }
                request['default_fields'] = default_fields;
            }

            this.widget.service.sjclient.raw.get(this.widget.service.search_api_path, request, (response) => {
                var facet = response.facets && response.facets[facets] || {};
                var terms = facet.terms || [];

                terms.forEach(term => {
                    var parts = term.term.split('\\');
                    parts.shift();
                    if (!parts[parts.length - 1]) {
                        parts.pop();
                    }
                    term.term = parts.join('\\');
                });

                callback(terms, facet.other || 0);
            });
        });
    }

    toggleLookup(e) {
        e.stopPropagation();
        this.showLookup = !this.showLookup;
    }

    searchTermResults(searchString, addMoreContainer) {
        let offsetParent = addMoreContainer;
        let addMoreOffset = addMoreContainer.offsetTop;

        while (offsetParent = offsetParent.offsetParent) {
            addMoreOffset += offsetParent.offsetTop;
        }

        var filterExp = "*" + (searchString || '') + "*";
        this.filterFacets(this.moreMaxFacets, filterExp, (terms, other) => {
            if (this.widget.settings.adjustFacets) {
                terms = this.widget.settings.adjustFacets(this.widget, terms, null, null, searchString || '');
            }
            terms = terms.map(t => {
                var fullTerm = t.term || '';
                var parts = fullTerm.split('\\');
                var prefix = parts.slice(0, parts.length - 1).join('\\');
                var item: any = {
                    term: parts[parts.length - 1],
                    count: t.count,
                    parts: parts,
                    fullTerm: fullTerm,
                    prefix: prefix
                };
                item.checked = this.isChecked(<any>item, prefix);
                return item;
            })
            this.allSearchTermResults = terms;
            this.searchMore = !!other;

            this.addMoreListMaxHeight = document.body.scrollHeight - addMoreOffset - 40 - (this.searchMore ? 30 : 0);

            this.showMoreSearchingSpinner = false;
            this.showSearchTermInput = true;
        });
    }

    onSearchTermClicked(item) {
        this.check(item, item.prefix);
    }

    globalMoreKeydownHandler = (event) => {
        if (this.showSearchTermInput) {
            var key = event.which;
            switch (key) {
                case 13:
                    // Key enter.
                    var itemToSelect = this.allSearchTermResults[this.highligted];
                    if (itemToSelect) {
                        this.onSearchTermClicked(itemToSelect);
                    }
                    event.preventDefault(); // prevent form submit (for embed view)
                    this.showSearchTermInput = false;
                    break;
                case 38:
                    // Key up.
                    if (this.highligted > 0) {
                        this.highligted--;
                    }
                    break;
                case 40:
                    // Key down.
                    if (this.highligted < this.allSearchTermResults.length - 1) {
                        this.highligted++;
                    }
                    break;
            }
        }
    };

    globalMoreMouseupHandler = (e) => {
        if (this.showSearchTermInput) {
            var el = <HTMLElement>e.target;
            if (el && el.classList) {
                for (var i = 0; i < el.classList.length; ++i) {
                    var _class = el.classList[i];
                    if (_class == "sjtreef-search-input")
                        return;
                }
            }
            this.showSearchTermInput = false;
        }
    };

    onMoreClick(addMoreContainer) {
        this.highligted = 0;

        if (!this.searchTermString) {
            return;
        }

        this.showMoreSearchingSpinner = true;
        this.searchTermResults(this.searchTermString, addMoreContainer);
    }

    get isGridMode() {
        return !!this.widget['grid'];
    }

    get sortQuery() {
        let sort = '';
        if (this.widget.settings.sort && this.widget.settings.sort !== SortOption.countDesc) {
            sort = `@sort:${this.widget.settings.sort}`;
        }

        return sort;
    }

    fieldWithSort(path = '') {
        return path ? `${this.field}@tree:${path}${this.sortQuery}` : `${this.field}@tree${this.sortQuery}`;
    }

    joinQueryParts(parts: string[]) {
        return parts.join(' OR ');
    }

    setTotals(term) {
        this.totalCount = term.total;
    }
}

var TreeFacetWidgetDefinition: IWidgetDefinition<TreeFacetData, ITreeFacetSettings, ITreeFacetState> = {
    init(widget) {
        widget.data = new TreeFacetData(widget);
    },
    getFacets(widget) {
        if (!widget.data.getSelArray().length) {
            if (widget.settings.field) {
                return [widget.data.fieldWithSort()];
            }
        }
    },
    getQuery(widget) {
        if (!widget.data || !widget.settings.field) {
            return;
        }
        var queryParts = [];
        var sel = widget.data.getSelArray(true);
        var dsel = widget.data.getSelArray(false);
        if (sel.length || dsel.length) {
            var operator = widget.settings.radio ? (widget.settings.radioAllNested ? ':' : '=') : ':';
            if (sel.length) {
                var parts = sel.map(item => {
                    return widget.service.helpers.formatQueryPart(widget.data.field, item, operator);
                });
                queryParts.push(widget.data.joinQueryParts(parts));
            }
            if (dsel.length) {
                var parts = dsel.map(item => {
                    return `NOT ${widget.service.helpers.formatQueryPart(widget.data.field, item, operator)}`;
                });
                queryParts.push(parts.join(' '));
            }
        } else if (widget.state.nullable === false && widget.state.all === false) {
            queryParts.push(`set:zzz`); // same as sjweb
        } else if (widget.data.isCheckedUncheckedMode() && widget.state.all === false) {
            queryParts.push(`set:zzz`);
        } else if (widget.state.nullable === false) {
            queryParts.push(`set:${widget.service.helpers.escapeQueryText(widget.data.fieldWithoutAt)}`);
        } else if (widget.state.all === false || widget.settings.radio) {
            queryParts.push(`NOT set:${widget.service.helpers.escapeQueryText(widget.data.fieldWithoutAt)}`);
        }
        return queryParts.join(' ');
    },
    beforeSearch(widget) {
        if (widget.data.shouldMakeSeparateRequest) {
            if (widget.data.preventNextChange) {
                widget.data.preventNextChange--;
                return;
            }
            //in other words, we have a query... can't trust main search facets
            widget.data.requestFacets(20, (terms) => {
                widget.data.setTerms(terms);
                widget.refreshGridContainerHeightIfNecessary();
            });
        }
    },
    onData(widget, data) {
        if (!widget.data.shouldMakeSeparateRequest) {
            if (widget.data.preventNextChange) {
                widget.data.preventNextChange--;
                return;
            }
        }
        if (data.success) {
            if (!widget.data.shouldMakeSeparateRequest) {
                var termsPart = data.facets && data.facets[widget.data.fieldWithSort()] || {};
                widget.data.missedCount = termsPart.missing;
                var terms = termsPart.terms || [];

                widget.data.setTerms(terms);

                widget.data.setTotals(termsPart);
            }
        } else {
            widget.data.setTerms([]);
        }
    },
    getSubFilters(widget) {

        if (widget.settings.radio) {
            return null;
        }

        function createFilter(filter: { value: string, label: string, disabled: boolean }): SubFilter {
            return {
                value: filter.value,
                label: filter.label,
                widgetId: widget.id,
                widgetLabel: typeof widget.settings.name == 'function' ? widget.settings.name(widget) : widget.settings.name,
                disabled: filter.disabled
            };
        }

        var selectedKeys = widget.data.getSelArray();

        var filters = selectedKeys.map(f => {
            var preselected = widget.data.preselected || {};
            return createFilter({
                value: f,
                label: f,
                disabled: preselected[f]
            });
        });

        return filters;
    },
    removeSubFilter(widget, filter: SubFilter) {
        if (filter.value && widget.state.selected) {
            delete widget.state.selected[filter.value];
        }
        if (widget.settings.onChange) {
            widget.settings.onChange(widget);
        }
    },
    stateInit(widget) {
        widget.data.stateInit();
    },
    notActiveAction: function (widget, action) {
        switch (action) {
            case 'beforeSearch':
                // if widget is not active ('settings.isActive()' returns false), then should drop currently shown/loaded terms
                widget.data.setTerms([]);
                break;
        }
    },
    destroy(widget) {
        widget.data.destroy && widget.data.destroy();
    },
    template,
    styles,
    classNames: ['sj-widget-rel'],
};

export { TreeFacetData, TreeFacetWidgetDefinition };